import React, {useState, useEffect} from 'react';
import {GrDocumentUpdate} from 'react-icons/gr';
import {Link, useNavigate} from 'react-router-dom';
import {ContentHeader, DatePicker, Loader} from '@components';
import {UpdateCase, UpdateCaseFollowUp} from '@app/services/case';
import {Button, Modal, Form} from 'react-bootstrap';
import {getAllAdminName} from '../../services/leaves';
import {logoutUser} from '@store/reducers/auth';
import {getAllCases} from '@app/services/case';
import Pagination from '../../components/pagination/index';
import {endOfDay, startOfDay} from 'date-fns';
import {getAllTodayCase} from '@app/services/case';
import {createActivity} from '@app/services/activity';
import handleStatus from '../../utils/ajax';
import {useSelector, useDispatch} from 'react-redux';
import {toast} from 'react-toastify';
import {object} from 'yup';

function ModalPopup({handleClose, caseId, allCaseFn}) {
  const [payload, setPayload] = useState({});
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const value = async (e) => {
    const changeDateFormat = e.target.value.split('-');
    const correctDateFormat =
      changeDateFormat[2] +
      '/' +
      changeDateFormat[1] +
      '/' +
      changeDateFormat[0];
    const payload = {followUpDate: correctDateFormat};
    setPayload(payload);
  };

  const UpdateCaseFn = async () => {
    if (Object.keys(payload).length === 0 || payload === undefined) {
      toast.error('Please Select a date');
    }
    if (Object.keys(payload).length > 0) {
      const resp = await UpdateCaseFollowUp({...payload, followUpRequire: true}, caseId);
      handleStatus(resp.status, () => dispatch(logoutUser()), navigate);
      if (resp.status === 200) {
        toast.success('Case has been updated');
        handleClose();
        allCaseFn();
      }
    }
  };

  return (
    <>
      <Modal show={true} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title> Follow Up</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="input-group w-60">
            <div className="col-md-12">
              <div className="form-group d-flex">
                <label htmlFor="datetimepicker2" className="col-md-5">
                  Request Follow Up:
                </label>
                <div className="input-group date" id="datetimepicker2">
                  <input
                    type="date"
                    className="form-control"
                    onChange={(e) => value(e)}
                  />
                  <span className="input-group-addon">
                    <span className="glyphicon glyphicon-calendar"></span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={UpdateCaseFn}>
            Follow Up
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

function ModalPopup2({handleClose, caseId}) {
  const [activityType, setActivityType] = useState('');
  const [comment, setComment] = useState('');
  const [disableFollowUp, setDisableFollowUp] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const checkBoxValue = async (e) => {
    if (e.target.checked) {
      setDisableFollowUp(true);
    }
  };

  const getActivityType = async (activity) => {
    setActivityType(activity);
  };

  const getComment = async (comment) => {
    setComment(comment);
  };
  const addActivity = async () => {
    if (
      activityType === null ||
      activityType === undefined ||
      activityType === ''
    ) {
      setActivityType('Comment');
    }

    if (comment === null || comment === undefined || comment === '') {
      toast.error('Please enter comment type');
    }

    if (comment && activityType) {
      const payload = {
        activityType: activityType,
        comment: comment,
        caseId: caseId,
        removeFollowUp: disableFollowUp
      };

      const resp = await createActivity(payload);
      handleStatus(resp.status, () => dispatch(logoutUser()), navigate);
      if (resp.status === 200) {
        toast.success('Activity has been added');
        handleClose();
      }
    }
  };

  return (
    <>
      <Modal show={true} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title> Add Activity</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="input-group w-60">
            <div className="form-group row form-form">
              <label htmlFor="inputSkills4" className="col-md-6 col-form-label">
                Activity Type
              </label>
              <div className="col-md-12">
                <select
                  className="form-control"
                  value={activityType}
                  onChange={(e) => getActivityType(e.target.value)}
                >
                  <option>Comment</option>
                  <option>Follow up Sent</option>
                  <option>Follow up Request</option>
                </select>
              </div>
            </div>
            <div className="form-group row form-form">
              <label htmlFor="inputReason" className="col-md-6 col-form-label">
                Comment
              </label>
              <div className="col-md-12 ml-1">
                <textarea
                  className="form-control"
                  id="inputReason"
                  placeholder="Comment"
                  onChange={(e) => getComment(e.target.value)}
                  value={comment}
                ></textarea>
              </div>
            </div>
          </div>
          <Form.Check
            type={'checkbox'}
            label={` Disable FollowUp`}
            onChange={(e) => checkBoxValue(e)}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={addActivity}>
            Add Activity
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

const Reply = ({value}) => {
  if (value === false) {
    return <span className="badge badge-danger">No</span>;
  }
  if (value === true) {
    return <span className="badge badge-success">Yes</span>;
  }
};

const Closed = ({value}) => {
  if (value === false) {
    return <span className="badge badge-danger">No</span>;
  }
  if (value === true) {
    return <span className="badge badge-success">Yes</span>;
  }
};

const Case = () => {
  const [users, setUsers] = useState([]);
  const [user, setUser] = useState('');
  const [currentCase, setCurrentCase] = useState(null);
  const [title, setTitle] = useState('');
  const childRef = React.useRef();
  const [allTodayCases, SetAllTodayCases] = useState([]);
  const [startDate, setStartDate] = useState(0);
  const [endDate, setEndDate] = useState(0);
  const [selected, setSelected] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [showModal2, setShowModal2] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [postPerPage] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const getAllCasesRecord = async () => {
    setShowLoader(true);
    const response = await getAllTodayCase();
    handleStatus(response.status, () => dispatch(logoutUser()), navigate);

    if (response.data.ok === true) {
      SetAllTodayCases(response.data.data);
      setTotalRecords(response.data.totalRecords);
    }
    setShowLoader(false);
  };

  // const getAllAdmin = async () => {
  //   const res = await getAllAdminName();
  //   handleStatus(res.status, () => dispatch(logoutUser()), navigate)
  //   if (res.data.ok) {
  //     setUsers(
  //       res.data.data.map((user) => ({value: user._id, label: user.name}))
  //     );
  //   }
  //   console.log(res, 'res');
  // };

  // const handleChange = (e) => {
  //   console.log(e.target.value);
  //   childRef.current.resetDatePicker();
  //   if (e.target.value.toLowerCase() === 'today') {
  //     const todayStartDate = startOfDay(new Date());
  //     const todayEndDate = endOfDay(new Date());
  //     console.log(
  //       todayStartDate,
  //       'todayStartDate',
  //       todayEndDate,
  //       'todayEndDate'
  //     );
  //     setStartDate(Date.parse(todayStartDate));
  //     setEndDate(Date.parse(todayEndDate));

  //     // getAll({ startDate:  Date.parse(todayStartDate) , endDate: Date.parse(todayEndDate)})
  //   } else if (e.target.value.toLowerCase() === 'yesterday') {
  //     const todayDate = Date.parse(new Date());

  //     const yesterDayDate = todayDate - 86400000;

  //     const yesterdayStartTime = startOfDay(new Date(yesterDayDate));
  //     const yesterdayEndTime = endOfDay(new Date(yesterDayDate));
  //     console.log(
  //       yesterdayStartTime,
  //       'yesterdayEndTime',
  //       yesterdayEndTime,
  //       'todayEndDate'
  //     );

  //     setStartDate(Date.parse(yesterdayStartTime));
  //     setEndDate(Date.parse(yesterdayEndTime));
  //   } else {
  //     setStartDate(0);
  //     setEndDate(0);
  //   }

  //   setSelected(e.target.value);
  // };

  // const onChange = (e) => {
  //   let value = e.target.value;
  //   if (value === 'Name') {
  //     value = null;
  //   }
  //   setUser(value);
  // };

  useEffect(() => {
    getAllCasesRecord();
  }, []);

  // const handleCustomDateChange = ({startDate, endDate}) => {
  //   console.log(startDate, 'startd', endDate);
  //   setStartDate(startDate);
  //   setEndDate(endDate);
  // };

  const paginate = (pageno) => {
    // getAllCasesRecord({startDate: startDate, endDate: endDate,searchText:title,userId:user,pageNo:pageno});

    setCurrentPage(pageno);

    //setCurrentPage(pageno);
  };

  const showPopup = (val) => {
    setShowModal(true);
    setCurrentCase(val._id);
  };
  const showPopup2 = (val) => {
    setShowModal2(true);
    setCurrentCase(val._id);
  };

  const handleClose = () => {
    setShowModal(false);
  };
  const handleClose2 = () => {
    setShowModal2(false);
  };

  // const filter = () => {
  //   getAllCasesRecord({startDate: startDate, endDate: endDate,searchText:title,userId:user});
  // };

  // const reset = ()=>{
  //   setTitle("")
  //   setUser ("")
  //   setSelected('')
  //   childRef.current.resetDatePicker();
  //   getAllCasesRecord();

  // }
  return (
    <React.Fragment>
      <ContentHeader title="Today's Cases" />
      {showModal && (
        <ModalPopup
          handleClose={handleClose}
          caseId={currentCase}
          allCaseFn={getAllCasesRecord}
        />
      )}
      {showModal2 && (
        <ModalPopup2 handleClose={handleClose2} caseId={currentCase} />
      )}
      <section className="content">
        <div className="container-fluid">
          <div className="card">
            <div className="card-header">
              <h3 className="card-title">About Cases</h3>
            </div>
            <div className="card-body">
              <div className="col-12">
                <div className="card">
                  <div className="card-header d-flex align-items-baseline">
                    <h3 className="card-title">All Cases</h3>
                    <div className="containercase d-flex align-items-baseline justify-content-end right"></div>
                  </div>
                  <div className="card-body table-responsive p-0">
                    {showLoader ? (
                      <Loader title={'Daily'} />
                    ) : (
                      <table className="table table-striped projects">
                        <thead>
                          <tr>
                            <th
                              className="col-md-2"
                              style={{paddingRight: '0px'}}
                            >
                              Client Name
                            </th>
                            <th
                              className="col-md-2"
                              style={{width: '10%', paddingRight: '0px'}}
                            >
                              Link Open
                            </th>
                            <th className="col-md-1">Points</th>
                            <th className="col-md-2">Category</th>
                            <th className="col-md-1">Reply</th>
                            <th className="col-md-1">Closed</th>
                            <th
                              className="col-md-2"
                              style={{
                                width: '20%',
                                paddingRight: '0px',
                                paddingLeft: '0px',
                                textAlign: 'end'
                              }}
                            >
                              Action
                            </th>
                            <th
                              className="col-md-2"
                              style={{width: '20%'}}
                            ></th>
                            <th
                              className="col-md-2"
                              style={{width: '20%'}}
                            ></th>
                          </tr>
                        </thead>
                        <tbody>
                          {allTodayCases &&
                            allTodayCases.map((val) => {
                              return (
                                <tr>
                                  <td style={{paddingRight: '0px'}}>
                                    {val.clientName}
                                  </td>
                                  <td style={{paddingRight: '0px'}}>
                                    <Link
                                      to={'/' + '/' + val.link}
                                      target="_blank"
                                    >
                                      Open Link
                                    </Link>
                                  </td>
                                  <td
                                    style={{
                                      paddingRight: '0px',
                                      textAlign: 'center'
                                    }}
                                  >
                                    {val.points}
                                  </td>
                                  <td>{val.category.category}</td>
                                  <td className="project_progress">
                                    <td>
                                      <Reply value={val.reply} />
                                    </td>
                                  </td>
                                  <td className="project-state">
                                    <td>
                                      <Closed value={val.closed} />
                                    </td>
                                  </td>
                                  <td className="project-actions">
                                    <button
                                      type="button"
                                      className="btn btn-primary button-of-cases"
                                      onClick={() => showPopup(val)}
                                    >
                                      Follow Up
                                    </button>
                                  </td>
                                  <td className="project-actions2">
                                    <button
                                      type="button"
                                      className="btn btn-primary button-of-cases"
                                      onClick={() => showPopup2(val)}
                                    >
                                      Add Activity
                                    </button>
                                  </td>
                                  <td className="case-actions">
                                    <Link
                                      to={'/view-activity/' + val._id}
                                      className="btn btn-primary btn-sm mr-2 button-of-cases"
                                    >
                                      <i className="fas fa-eye"></i>
                                    </Link>
                                    <Link
                                      to={'/update-case/' + val._id}
                                      className="btn btn-primary btn-sm mr-2"
                                    >
                                      <GrDocumentUpdate />
                                    </Link>
                                  </td>
                                </tr>
                              );
                            })}
                        </tbody>
                      </table>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <Pagination
              postsPerPage={postPerPage}
              totalPosts={totalRecords}
              paginate={paginate}
              currentPage={currentPage}
            ></Pagination>
          </div>
        </div>
      </section>
    </React.Fragment>
  );
};

export default Case;
